import React from 'react';
import { CheckIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
import { masteryItems } from '../data/content';
const RECIPES_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/d48ee120-c4c8-4cce-90ac-a46ae50fcba7.jpg';
const PACKAGING_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/2079b904-19d4-469d-b5de-805d8ac22fd2.jpg';
export function Mastery() {
  return <section className="w-full bg-cream paper-grain" data-id="element-78" data-mp="3tqj7jvvlj54n">
      <div className="mx-auto w-full max-w-6xl px-5 py-12 sm:px-6 sm:py-16 lg:py-24" data-id="element-79" data-mp="2l12q6rx5bh7">
        <SectionLabel data-id="element-80" data-mp="7cj1qpadt1zj">Lo que vas a dominar</SectionLabel>
        <h2 className="max-w-2xl font-display text-[1.6rem] leading-tight text-ink sm:text-4xl" data-id="element-81" data-mp="7f59aox9vhhr">
          Del primer molde a tu marca de autor
        </h2>

        <div className="mt-8 grid gap-8 sm:mt-10 sm:gap-10 lg:grid-cols-[1.1fr_0.9fr] lg:items-center" data-id="element-82" data-mp="ges9j7e9mh98">
          <ul className="grid gap-3 sm:grid-cols-2 sm:gap-4" data-id="element-83" data-mp="ldbvh7suzt1l">
            {masteryItems.map((item, index) => <motion.li key={item.title} initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.5,
            delay: index * 0.08
          }} className="rounded-2xl border border-sage/30 bg-white/60 p-5 sm:p-6" data-id="element-84" data-mp="332dko15n90ne" data-mpi={index}>
                <span className="mb-3 flex h-8 w-8 items-center justify-center rounded-full bg-sage/20 text-moss sm:mb-4" data-id="element-85" data-mp="3lr2047lcydrs">
                  <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-86" data-mp="3hs2wqrf9yp2g" />
                </span>
                <h3 className="font-display text-xl text-ink" data-id="element-87" data-mp="3cxf54joz5ejn">{item.title}</h3>
                <p className="mt-2 font-sans text-sm leading-relaxed text-ink/65" data-id="element-88" data-mp="37zdm1yrjtf86">
                  {item.description}
                </p>
              </motion.li>)}
          </ul>

          <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:gap-5" data-id="element-89" data-mp="4ioi8kjcojm7">
            <img src={RECIPES_IMAGE} alt="Ingredientes naturales para jabones: arcillas, café molido, avena y pétalos" className="aspect-square w-full rounded-2xl object-cover shadow-soft" data-id="element-90" data-mp="nf6v127owyvj" />
            <img src={PACKAGING_IMAGE} alt="Jabones artesanales envueltos en papel kraft con hilo y flores prensadas" className="aspect-square w-full rounded-2xl object-cover shadow-soft lg:translate-y-6" data-id="element-91" data-mp="en4uz51j9kls" />
          </div>
        </div>
      </div>
    </section>;
}